import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import softwareDetailsActions from '../actions/softwareDetails';
import confirmationActions from '../actions/confirmationPage';
import {MERCHANT_OF_RECORD} from '../utils/constants';

function handleIpmFlow(store, error, response) {
    if (error) {
        store.dispatch(actions.enableLoadOverLay(false));
        store.dispatch(softwareDetailsActions.alertError('ipmob.internal.server.error'));
    } else {
        try {
            const res = JSON.parse(response.text);
            const businessModelType = res.businessModel;

            if (businessModelType) {
                if (businessModelType === MERCHANT_OF_RECORD.AGENCY) {
                    store.dispatch(actions.enableLoadOverLay(false));
                    store.dispatch(actions.changeAppState('LISTING_MODEL'));
                } else if (businessModelType === MERCHANT_OF_RECORD.EXPEDIA) {
                    store.dispatch(actions.enableLoadOverLay(false));
                    store.dispatch(actions.changeAppState('PAYOUT_DETAILS'));
                } else {
                    // UNSPECIFIED
                    store.dispatch(actions.changeAppState('BUSINESS_MODEL'));
                }
            } else {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(softwareDetailsActions.alertError('ipmob.error.process.request'));
            }

        } catch (exp) {
            store.dispatch(actions.enableLoadOverLay(false));
            store.dispatch(softwareDetailsActions.alertError('ipmob.error.process.request'));
        }
    }
}

function handleBusinessModelSwitchFlow(store, error, response) {
    if (error) {
        store.dispatch(confirmationActions.alertError('ipmob.internal.server.error'));
    } else {
        try {
            const res = JSON.parse(response.text);

            // eslint-disable-next-line no-unused-vars
            const businessModelType = res.businessModel;

            // TODO: PSSO-1480 Pass businessModelType to confirmationPage to determine whether BMX option is visible

        } catch (exp) {
            store.dispatch(confirmationActions.alertError('ipmob.error.process.request'));
        }
    }
    store.dispatch(actions.enableLoadOverLay(false));
}

function getPreferredBusinessModel(store, action) {
    const systemId = action.payload.systemId;
    const pmType = action.payload.pmType;
    request.get(`/${config.url_prefix}/api/getPreferredBusinessModel?systemId=${systemId}`)
        .end((error, response) => {
            switch (pmType) {
                case 'IPM':
                case 'PPM':
                case 'IPM_SOFTWARE_SWITCH':
                    handleIpmFlow(store, error, response);
                    break;
                default:
                    handleBusinessModelSwitchFlow(store, error, response);
                    break;
            }
        });
}

export default getPreferredBusinessModel;
